// Copyright (C) 2025 Skylark Drones

import dayjs from 'dayjs'
import { subscriptionStatus } from '@/constants/subscriptions'

/**
 * Calculates the number of whole days remaining until a plan expires.
 * Defaults to 0 days ahead of "now" when no expiry timestamp is provided.
 *
 * @param {dayjs.ConfigType | null | undefined} validTill Raw expiry date/time value.
 * @returns {number} Days until expiry (negative when already expired).
 */
export function daysToCompanyPlanExpiry(validTill) {
  return dayjs(validTill).diff(dayjs(), 'day')
}

/**
 * Indicates whether a cancel-scheduled plan is within the seven-day expiry window.
 *
 * @param {dayjs.ConfigType | null | undefined} validTill Raw expiry date/time value.
 * @param {string | undefined} status Current subscription status.
 * @returns {boolean}
 */
export function isCompanyPlanExpiryClose(validTill, status) {
  return (
    daysToCompanyPlanExpiry(validTill) <= 7 &&
    status === subscriptionStatus.CANCEL_SCHEDULED
  )
}
